import { preloadableLazy } from "./preloadableLazy.jsx";

export const routePages = {
  DashboardPage: preloadableLazy(() => import("../pages/DashboardPage.jsx")),
  YourBusinessPage: preloadableLazy(() => import("../pages/YourBusinessPage.jsx")),
  DashboardChatsPage: preloadableLazy(() => import("../pages/DashboardChatsPage.jsx")),
  DashboardShellLayout: preloadableLazy(() => import("../components/dashboard/DashboardShellLayout.jsx")),
  GrantApplicationToolkit: preloadableLazy(() => import("../pages/GrantApplicationToolkit.jsx")),
  ApplicationGeneratorPage: preloadableLazy(() => import("../pages/ApplicationGeneratorPage.jsx")),
  GrantApplicationSimulatorPage: preloadableLazy(() => import("../pages/GrantApplicationSimulatorPage.jsx")),
  GrantOperationsHubPage: preloadableLazy(() => import("../pages/GrantOperationsHubPage.jsx")),
  AskOptraPage: preloadableLazy(() => import("../pages/AskOptraPage.tsx")),
  GrantComplianceReviewPage: preloadableLazy(() => import("../pages/GrantComplianceReviewPage.jsx")),
  GrantComplianceReviewResultsPage: preloadableLazy(() => import("../pages/GrantComplianceReviewResultsPage.jsx")),
  VendorIntelligencePage: preloadableLazy(() => import("../pages/VendorIntelligencePage.jsx")),
  VendorProfilePage: preloadableLazy(() => import("../pages/VendorProfilePage.jsx")),
  DashboardFilesPage: preloadableLazy(() => import("../pages/DashboardFilesPage.jsx")),
  IntegrationsPage: preloadableLazy(() => import("../pages/IntegrationsPage.jsx")),
  OurPartnersPage: preloadableLazy(() => import("../pages/OurPartnersPage.jsx")),
  AdminAssessmentsPage: preloadableLazy(() => import("../pages/AdminAssessmentsPage.jsx")),
  LoginPage: preloadableLazy(() => import("../pages/LoginPage.jsx")),
  SubscribePage: preloadableLazy(() => import("../pages/SubscribePage.jsx")),
  AuthCallbackPage: preloadableLazy(() => import("../pages/AuthCallbackPage.jsx")),
  ResultsAsyncEnhanced: preloadableLazy(() => import("../pages/ResultsAsyncEnhanced.jsx")),
  EligibilityResults: preloadableLazy(() => import("../pages/EligibilityResults.jsx")),
  WaitlistPage: preloadableLazy(() => import("../pages/WaitlistPage.jsx")),
  PrivacyPage: preloadableLazy(() => import("../pages/PrivacyPage.jsx")),
  TermsPage: preloadableLazy(() => import("../pages/TermsPage.jsx")),
  SingaporeComparePage: preloadableLazy(() => import("../pages/SingaporeComparePage.jsx")),
  BlogPostPage: preloadableLazy(() => import("../pages/BlogPostPage.jsx")),
  EligibilityAssessmentPage: preloadableLazy(() => import("../pages/EligibilityAssessmentPage.jsx")),
  AdminClientOpsPage: preloadableLazy(() => import("../pages/AdminClientOpsPage.jsx")),
  AdminClientDetailPage: preloadableLazy(() => import("../pages/AdminClientDetailPage.jsx")),
  AdminClientResultsPage: preloadableLazy(() => import("../pages/AdminClientResultsPage.jsx")),
  RegionNoAccessPage: preloadableLazy(() => import("../pages/RegionNoAccessPage.jsx")),
  RegionChooserPage: preloadableLazy(() => import("../pages/RegionChooserPage.jsx")),
  GlobalBlogPage: preloadableLazy(() => import("../pages/GlobalBlogPage.jsx")),
  GlobalAboutPage: preloadableLazy(() => import("../pages/GlobalAboutPage.jsx")),
  UsSiteRoutes: preloadableLazy(() => import("../regions/us/UsSiteRoutes.jsx")),
};

const moduleLoaders = {
  dashboard: () => Promise.all([
    routePages.DashboardShellLayout.preload(),
    routePages.DashboardPage.preload(),
  ]),
  business: routePages.YourBusinessPage.preload,
  documents: routePages.DashboardFilesPage.preload,
  messages: routePages.DashboardChatsPage.preload,
  ask: routePages.AskOptraPage.preload,
  assessment: routePages.EligibilityAssessmentPage.preload,
  results: routePages.EligibilityResults.preload,
  assessmentProgress: routePages.ResultsAsyncEnhanced.preload,
  clientOps: routePages.AdminClientOpsPage.preload,
  adminAssessments: routePages.AdminAssessmentsPage.preload,
  adminClient: routePages.AdminClientDetailPage.preload,
  adminClientResults: routePages.AdminClientResultsPage.preload,
  roadmap: routePages.GrantApplicationToolkit.preload,
  composer: routePages.ApplicationGeneratorPage.preload,
  simulator: routePages.GrantApplicationSimulatorPage.preload,
  compliance: routePages.GrantComplianceReviewPage.preload,
  complianceResults: routePages.GrantComplianceReviewResultsPage.preload,
  vendor: routePages.VendorIntelligencePage.preload,
  vendorProfile: routePages.VendorProfilePage.preload,
  postApproval: routePages.GrantOperationsHubPage.preload,
  partners: routePages.OurPartnersPage.preload,
  login: routePages.LoginPage.preload,
  subscribe: routePages.SubscribePage.preload,
  compare: routePages.SingaporeComparePage.preload,
  privacy: routePages.PrivacyPage.preload,
  terms: routePages.TermsPage.preload,
  blogPost: routePages.BlogPostPage.preload,
};

const pendingModules = new Map();

function moduleKeyForPath(value) {
  let pathname = String(value || "").split(/[?#]/)[0];
  pathname = pathname.replace(/^\/(sg|us)(?=\/|$)/, "") || "/";
  if (pathname.startsWith("/dashboard/clients/")) {
    return pathname.includes("/assessments/") ? "adminClientResults" : "adminClient";
  }
  if (pathname.startsWith("/submission-files/")) return "documents";
  if (pathname.startsWith("/vendor-intelligence/vendor/")) return "vendorProfile";
  if (pathname.startsWith("/blog/")) return "blogPost";
  if (pathname.startsWith("/shared/eligibility/")) return "results";
  const routes = {
    "/dashboard": "dashboard",
    "/workflow": "dashboard",
    "/business": "business",
    "/submission-files": "documents",
    "/dashboard/chats": "messages",
    "/ask": "ask",
    "/dashboard/eligibility-assessment": "assessment",
    "/dashboard/results": "results",
    "/shared/eligibility": "results",
    "/dashboard/assessment-progress": "assessmentProgress",
    "/dashboard/client-ops": "clientOps",
    "/dashboard/admin-assessments": "adminAssessments",
    "/grant-roadmap": "roadmap",
    "/application-composer": "composer",
    "/grant-application-simulator": "simulator",
    "/grant-compliance-review": "compliance",
    "/grant-compliance-review/results": "complianceResults",
    "/vendor-intelligence": "vendor",
    "/post-approval-operations": "postApproval",
    "/our-partners": "partners",
    "/login": "login",
    "/subscribe": "subscribe",
    "/compare": "compare",
    "/privacy": "privacy",
    "/terms": "terms",
  };
  return routes[pathname] || "";
}

export function preloadRouteModule(path) {
  const key = moduleKeyForPath(path);
  if (!key) return Promise.resolve();
  if (!pendingModules.has(key)) {
    const pending = moduleLoaders[key]().catch(() => {
      pendingModules.delete(key);
    });
    pendingModules.set(key, pending);
  }
  return pendingModules.get(key);
}

export function scheduleIdlePreloads(loaders) {
  const queue = [...loaders];
  let cancelled = false;
  let idleId = null;
  let timerId = null;

  const scheduleNext = () => {
    if (cancelled || queue.length === 0) return;
    const run = () => {
      if (cancelled) return;
      void Promise.resolve().then(queue.shift()).catch(() => {}).finally(() => {
        timerId = window.setTimeout(scheduleNext, 120);
      });
    };
    if (typeof window.requestIdleCallback === "function") {
      idleId = window.requestIdleCallback(run, { timeout: 1000 });
    } else {
      timerId = window.setTimeout(run, 250);
    }
  };

  scheduleNext();
  return () => {
    cancelled = true;
    if (idleId !== null) window.cancelIdleCallback?.(idleId);
    if (timerId !== null) window.clearTimeout(timerId);
  };
}

export function scheduleRoutePreloads(paths) {
  return scheduleIdlePreloads([...new Set(paths)].map((path) => () => preloadRouteModule(path)));
}
